import React from "react"
import Layout from '../components/mylayout'
import Recent from '../components/recent-posts'
import IconPack from '../components/iconpack'
import SEO from '../components/seo'

const Home = ({location}) => {
  return(
    <Layout location={location}>
    <SEO 
        title="Roshan R" 
        description="Hey, i am Roshan. I’m a CSE Undergraduate Student, 
        Web Developer and a Quantum Computing Enthusiast from Kerala, India. Roshan Rajeev is a personal blog where I publish articles and notes about software engineering, technology, science, and projects I am working on.

Visitors can read articles publicly without creating an account. Google Sign-In is provided for authenticated features on the website, such as identifying users and enabling personalized or account-specific functionality.

When you sign in with Google, the website only uses the basic account information required for authentication, such as your name, email address, and Google account identifier."
    />
    
    <div className="Hero">
        <div className="container">
            <div className="content">
                <h1 className="heading">Roshan Rajeev</h1>
                <p className="sub-heading">Roshan Rajeev is a personal blog where I publish articles and notes about software engineering, technology, science, and projects I am working on.

Visitors can read articles publicly without creating an account. Google Sign-In is provided for authenticated features on the website, such as identifying users and enabling personalized or account-specific functionality.

When you sign in with Google, the website only uses the basic account information required for authentication, such as your name, email address, and Google account identifier.</p>
                <IconPack/>
            </div>
        </div>
    </div>

    <Recent/>
    </Layout>
  )
}

export default Home;
